import { ActionTypes } from 'redux/utils/Value'

export default ActionTypes('ALLERGY_COUNT')